<template>
  <div class="page">
    <batch-query-list
      title="Resultados das Consultas em Lote"
      subtitle="Nesta tela você cria e verifica resultados de consultas em lote."
      :create-route="{ name: 'Compliance-Legal-Person-Create' }"
    />
  </div>
</template>

<script>
import BatchQueryList from '@/compliance/components/BatchQueryList.vue';

export default {
  name: 'ResultBatch',

  components: {
    BatchQueryList,
  },
};
</script>

<style scoped>

</style>
